"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionDefault = void 0;
const sessionDefault = {
  userId: "",
  sessionId: "",
  pageViewId: "",
  deeplinkId: "",
  affiliate: null,
  UTMs: {}
};
exports.sessionDefault = sessionDefault;